/* Publish by EComposer at 2025-07-29 11:01:20*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9x8xwj5vgtb"]=  window.__ectimmers["ecom-9x8xwj5vgtb"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-9x8xwj5vgtb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9x8xwj5vgtb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rma14bk3sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rma14bk3sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkop5585krq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkop5585krq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2py4xq5wclb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2py4xq5wclb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e88l81zddp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e88l81zddp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4se0vfhscow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4se0vfhscow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfuwxqx281q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfuwxqx281q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dlm9knwqb35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dlm9knwqb35', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0xfucktfqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0xfucktfqe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2hp6myl0hk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2hp6myl0hk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4u7lsrp1fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4u7lsrp1fk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whlj463bhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whlj463bhe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwxdxpos4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwxdxpos4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zaerq36kfoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zaerq36kfoa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unw8zfwdrp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unw8zfwdrp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tvmukpstkmp"]=  window.__ectimmers["ecom-tvmukpstkmp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-tvmukpstkmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvmukpstkmp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25kr8ztwfr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25kr8ztwfr9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1prr6cuxqjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1prr6cuxqjf', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6okdegxml9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6okdegxml9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22af5ejefj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22af5ejefj5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47abe5wlxn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47abe5wlxn8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qbkx3vhvon').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qbkx3vhvon', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yt5jgemufw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yt5jgemufw', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dr37e9dc56j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dr37e9dc56j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21seh31wxp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21seh31wxp9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q98jr9oe3oh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q98jr9oe3oh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c56y0umjs5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c56y0umjs5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h38qnmxq9br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h38qnmxq9br', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljbvw6hmg3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljbvw6hmg3', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wuxbyvqc1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wuxbyvqc1b', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}